/**
 * @file
 * Mega menu behavior for dynamic image sizing and level 3 management.
 */

(function ($, Drupal, once) {
  'use strict';

  /**
   * Mega menu behavior.
   */
  Drupal.behaviors.megaMenu = {
    attach: function (context, settings) {
      once('mega-menu', '.mega-dropdown', context).forEach(function (element) {
        var $dropdown = $(element);
        var $level2Links = $dropdown.find('.level-2-link');
        var $level3Contents = $dropdown.find('.level-3-content');

        if ($level3Contents.length > 0) {
          var $firstContent = $level3Contents.first();
          $firstContent.show();
          $level2Links.first().addClass('active');

          Drupal.behaviors.megaMenu.applyDynamicLayout($firstContent);
        }

        $level2Links.on('mouseenter', function (e) {
          e.preventDefault();

          var $link = $(this);
          var $parentLi = $link.closest('li');
          var targetId = $parentLi.data('target');

          $level2Links.removeClass('active');

          $link.addClass('active');

          $level3Contents.hide();

          var $targetContent = $dropdown.find('#' + targetId);
          $targetContent.show();

          Drupal.behaviors.megaMenu.applyDynamicLayout($targetContent);
        });
      });
    },

    /**
     * Applique le layout dynamique basé sur le nombre d'éléments.
     */
    applyDynamicLayout: function ($container) {
      var $imageContainer = $container.find('.mega-menu-images');
      var $items = $imageContainer.find('.mega-menu-image-item');
      var count = parseInt($imageContainer.data('count'), 10);

      // Retirer toutes les classes existantes
      $items.removeClass('col-12 col-6 col-4 col-3');
      $imageContainer.removeClass('layout-1 layout-2 layout-3 layout-4 layout-5 layout-6');

      // Appliquer les classes selon le nombre d'éléments
      switch (count) {
        case 1:
          $items.addClass('col-12');
          $imageContainer.addClass('layout-1');
          break;
        case 2:
          $items.addClass('col-6');
          $imageContainer.addClass('layout-2');
          break;
        case 3:
          $items.addClass('col-4');
          $imageContainer.addClass('layout-3');
          break;
        case 4:
          $items.addClass('col-6');
          $imageContainer.addClass('layout-4');
          break;
        case 5:
        case 6:
          $items.addClass('col-4');
          $imageContainer.addClass('layout-' + count);
          break;
        default:
          $items.addClass('col-4');
          $imageContainer.addClass('layout-default');
      }

      $container.find('img[data-src]').each(function () {
        if (typeof $(this).data('lazy') !== 'undefined') {
          $(this).trigger('appear');
        }
      });
    }
  };

  /**
   * Comportement pour la gestion des survols et animations.
   */
  Drupal.behaviors.megaMenuHover = {
    attach: function (context, settings) {
      once('mega-menu-hover', '.mega-menu-card', context).forEach(function (element) {
        var $card = $(element);

        $card.on('mouseenter', function () {
          $(this).addClass('hover');
        }).on('mouseleave', function () {
          $(this).removeClass('hover');
        });
      });
    }
  };

  /**
   * Comportement pour les animations d'ouverture/fermeture du menu.
   */
  Drupal.behaviors.megaMenuAnimation = {
    attach: function (context, settings) {
      once('mega-menu-animation', '.mega-dropdown', context).forEach(function (element) {
        var $dropdown = $(element);
        var $menu = $dropdown.find('.mega-menu');

        $dropdown.on('mouseenter', function () {
          $dropdown.addClass('show');
          $menu.addClass('animate-in');
        });

        $dropdown.on('mouseleave', function () {
          $dropdown.removeClass('show');
          $menu.removeClass('animate-in');
        });
      });
    }
  };

})(jQuery, Drupal, once);
